
import type { PropType } from 'vue'
import type { NvCalendarPeriod } from './Calendar.types'

import { computed, defineComponent } from 'vue'

export default defineComponent({
    props: {
        deletable :{
            type: Boolean,
            default: false,
        },
        period: {
            type: Array as PropType<NvCalendarPeriod>,
            default: () => []
        }
    },
    emits: ['delete'],
    setup(props, { emit }) {
        const onDelete = () => {
            if (props.deletable) {
                emit('delete')
            }
        }

        const getMonthCountInclusive = (date1: Date, date2: Date): number => {
            const year1 = date1.getFullYear()
            const year2 = date2.getFullYear()

            const month1 = date1.getMonth()
            const month2 = date2.getMonth()

            return (year2 - year1) * 12 + (month2 - month1) + 1
        }

        const badgeDates = computed(() => {
            if (props.period.length > 0) {
                if (props.period.length === 1) {
                    const startDateYear = props.period[0].getFullYear()
                    const startDateMonth = props.period[0].toLocaleString('ru-RU', { month: 'long' })
                    const startDateDay = props.period[0].getDate()
                    
                    return [
                        {
                            year: startDateYear,
                            monthName: startDateMonth,
                            day: startDateDay,
                            endDay: null,
                        }
                    ]
                }

                if (props.period.length === 2) {
                    const badges = [] as { year: number; monthName: string; day: number; endDay: number | null }[]
                    const totalMonths = getMonthCountInclusive(props.period[0], props.period[1])

                    for (let i = 0; i <= totalMonths - 1; i++) {
                        if (totalMonths === 1) {
                            badges.push({
                                year: props.period[0].getFullYear(),
                                monthName: props.period[0].toLocaleString('ru-RU', { month: 'long' }),
                                day: props.period[0].getDate(),
                                endDay: props.period[0].getDate() === props.period[1].getDate() ? null : props.period[1].getDate()
                            })
                        } else {
                            if (i === 0) {
                                const totalDaysInMonth = new Date(props.period[0].getFullYear(), props.period[0].getMonth() + 1, 0).getDate()

                                badges.push({
                                    year: props.period[0].getFullYear(),
                                    monthName: props.period[0].toLocaleString('ru-RU', { month: 'long' }),
                                    day: props.period[0].getDate(),
                                    endDay: props.period[0].getDate() === totalDaysInMonth ? null : totalDaysInMonth,
                                })
                            } else if (i === totalMonths - 1) {
                                badges.push({
                                    year: props.period[1].getFullYear(),
                                    monthName: props.period[1].toLocaleString('ru-RU', { month: 'long' }),
                                    day: 1,
                                    endDay: props.period[1].getDate() === 1 ? null : props.period[1].getDate()
                                })
                            } else {
                                const date = new Date(props.period[0].getFullYear(), props.period[0].getMonth() + i, 1, 12)
                                const totalDaysInMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()

                                badges.push({
                                    year: date.getFullYear(),
                                    monthName: date.toLocaleString('ru-RU', { month: 'long' }),
                                    day: 1,
                                    endDay: totalDaysInMonth
                                })
                            }
                        }
                    }

                    return badges
                }
            }

            return []
        })

        return {
            onDelete,
            badgeDates,
        }
    }
})
